import type {ISelectOption} from 'src/types/Form';

export const TIMEZONE_OPTIONS: ISelectOption[] = [
  {id: 'America/New_York', label: 'America/New_York (ET)'},
  {id: 'America/Chicago', label: 'America/Chicago (CT)'},
  {id: 'America/Denver', label: 'America/Denver (MT)'},
  {id: 'America/Phoenix', label: 'America/Phoenix (MST)'},
  {id: 'America/Los_Angeles', label: 'America/Los_Angeles (PT)'},
  {id: 'America/Anchorage', label: 'America/Anchorage (AKT)'},
  {id: 'Pacific/Honolulu', label: 'Pacific/Honolulu (HT)'},
  {id: 'America/Toronto', label: 'America/Toronto'},
  {id: 'America/Vancouver', label: 'America/Vancouver'},
  {id: 'America/Mexico_City', label: 'America/Mexico_City'},
  {id: 'America/Bogota', label: 'America/Bogota'},
  {id: 'America/Lima', label: 'America/Lima'},
  {id: 'America/Santiago', label: 'America/Santiago'},
  {id: 'America/Sao_Paulo', label: 'America/Sao_Paulo'},
  {id: 'America/Argentina/Buenos_Aires', label: 'America/Argentina/Buenos_Aires'},
  {id: 'Atlantic/Reykjavik', label: 'Atlantic/Reykjavik (UTC)'},
  {id: 'Europe/London', label: 'Europe/London (GMT/BST)'},
  {id: 'Europe/Dublin', label: 'Europe/Dublin'},
  {id: 'Europe/Lisbon', label: 'Europe/Lisbon'},
  {id: 'Europe/Paris', label: 'Europe/Paris (CET)'},
  {id: 'Europe/Berlin', label: 'Europe/Berlin'},
  {id: 'Europe/Amsterdam', label: 'Europe/Amsterdam'},
  {id: 'Europe/Brussels', label: 'Europe/Brussels'},
  {id: 'Europe/Madrid', label: 'Europe/Madrid'},
  {id: 'Europe/Rome', label: 'Europe/Rome'},
  {id: 'Europe/Warsaw', label: 'Europe/Warsaw'},
  {id: 'Europe/Stockholm', label: 'Europe/Stockholm'},
  {id: 'Europe/Oslo', label: 'Europe/Oslo'},
  {id: 'Europe/Copenhagen', label: 'Europe/Copenhagen'},
  {id: 'Europe/Helsinki', label: 'Europe/Helsinki'},
  {id: 'Europe/Athens', label: 'Europe/Athens'},
  {id: 'Europe/Bucharest', label: 'Europe/Bucharest'},
  {id: 'Europe/Kyiv', label: 'Europe/Kyiv'},
  {id: 'Europe/Moscow', label: 'Europe/Moscow'},
  {id: 'Asia/Dubai', label: 'Asia/Dubai'},
  {id: 'Asia/Karachi', label: 'Asia/Karachi'},
  {id: 'Asia/Kolkata', label: 'Asia/Kolkata'},
  {id: 'Asia/Dhaka', label: 'Asia/Dhaka'},
  {id: 'Asia/Bangkok', label: 'Asia/Bangkok'},
  {id: 'Asia/Singapore', label: 'Asia/Singapore'},
  {id: 'Asia/Shanghai', label: 'Asia/Shanghai'},
  {id: 'Asia/Hong_Kong', label: 'Asia/Hong_Kong'},
  {id: 'Asia/Tokyo', label: 'Asia/Tokyo'},
  {id: 'Asia/Seoul', label: 'Asia/Seoul'},
  {id: 'Australia/Perth', label: 'Australia/Perth'},
  {id: 'Australia/Adelaide', label: 'Australia/Adelaide'},
  {id: 'Australia/Darwin', label: 'Australia/Darwin'},
  {id: 'Australia/Brisbane', label: 'Australia/Brisbane'},
  {id: 'Australia/Sydney', label: 'Australia/Sydney'},
  {id: 'Australia/Melbourne', label: 'Australia/Melbourne'},
  {id: 'Pacific/Auckland', label: 'Pacific/Auckland'},
  {id: 'Pacific/Fiji', label: 'Pacific/Fiji'},
  {id: 'Africa/Cairo', label: 'Africa/Cairo'},
  {id: 'Africa/Johannesburg', label: 'Africa/Johannesburg'},
  {id: 'Africa/Lagos', label: 'Africa/Lagos'},
  {id: 'Africa/Nairobi', label: 'Africa/Nairobi'},
];

export const COUNTRY_OPTIONS: ISelectOption[] = [
  {id: 'Afghanistan', label: 'Afghanistan'},
  {id: 'Albania', label: 'Albania'},
  {id: 'Algeria', label: 'Algeria'},
  {id: 'Argentina', label: 'Argentina'},
  {id: 'Armenia', label: 'Armenia'},
  {id: 'Australia', label: 'Australia'},
  {id: 'Austria', label: 'Austria'},
  {id: 'Azerbaijan', label: 'Azerbaijan'},
  {id: 'Bahrain', label: 'Bahrain'},
  {id: 'Bangladesh', label: 'Bangladesh'},
  {id: 'Belarus', label: 'Belarus'},
  {id: 'Belgium', label: 'Belgium'},
  {id: 'Bolivia', label: 'Bolivia'},
  {id: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina'},
  {id: 'Brazil', label: 'Brazil'},
  {id: 'Bulgaria', label: 'Bulgaria'},
  {id: 'Cambodia', label: 'Cambodia'},
  {id: 'Canada', label: 'Canada'},
  {id: 'Chile', label: 'Chile'},
  {id: 'China', label: 'China'},
  {id: 'Colombia', label: 'Colombia'},
  {id: 'Costa Rica', label: 'Costa Rica'},
  {id: 'Croatia', label: 'Croatia'},
  {id: 'Cuba', label: 'Cuba'},
  {id: 'Cyprus', label: 'Cyprus'},
  {id: 'Czech Republic', label: 'Czech Republic'},
  {id: 'Denmark', label: 'Denmark'},
  {id: 'Dominican Republic', label: 'Dominican Republic'},
  {id: 'Ecuador', label: 'Ecuador'},
  {id: 'Egypt', label: 'Egypt'},
  {id: 'El Salvador', label: 'El Salvador'},
  {id: 'Estonia', label: 'Estonia'},
  {id: 'Ethiopia', label: 'Ethiopia'},
  {id: 'Finland', label: 'Finland'},
  {id: 'France', label: 'France'},
  {id: 'Georgia', label: 'Georgia'},
  {id: 'Germany', label: 'Germany'},
  {id: 'Ghana', label: 'Ghana'},
  {id: 'Greece', label: 'Greece'},
  {id: 'Guatemala', label: 'Guatemala'},
  {id: 'Honduras', label: 'Honduras'},
  {id: 'Hong Kong', label: 'Hong Kong'},
  {id: 'Hungary', label: 'Hungary'},
  {id: 'Iceland', label: 'Iceland'},
  {id: 'India', label: 'India'},
  {id: 'Indonesia', label: 'Indonesia'},
  {id: 'Iran', label: 'Iran'},
  {id: 'Iraq', label: 'Iraq'},
  {id: 'Ireland', label: 'Ireland'},
  {id: 'Israel', label: 'Israel'},
  {id: 'Italy', label: 'Italy'},
  {id: 'Jamaica', label: 'Jamaica'},
  {id: 'Japan', label: 'Japan'},
  {id: 'Jordan', label: 'Jordan'},
  {id: 'Kazakhstan', label: 'Kazakhstan'},
  {id: 'Kenya', label: 'Kenya'},
  {id: 'Kuwait', label: 'Kuwait'},
  {id: 'Latvia', label: 'Latvia'},
  {id: 'Lebanon', label: 'Lebanon'},
  {id: 'Libya', label: 'Libya'},
  {id: 'Lithuania', label: 'Lithuania'},
  {id: 'Luxembourg', label: 'Luxembourg'},
  {id: 'Malaysia', label: 'Malaysia'},
  {id: 'Mexico', label: 'Mexico'},
  {id: 'Morocco', label: 'Morocco'},
  {id: 'Myanmar', label: 'Myanmar'},
  {id: 'Nepal', label: 'Nepal'},
  {id: 'Netherlands', label: 'Netherlands'},
  {id: 'New Zealand', label: 'New Zealand'},
  {id: 'Nicaragua', label: 'Nicaragua'},
  {id: 'Nigeria', label: 'Nigeria'},
  {id: 'Norway', label: 'Norway'},
  {id: 'Oman', label: 'Oman'},
  {id: 'Pakistan', label: 'Pakistan'},
  {id: 'Panama', label: 'Panama'},
  {id: 'Paraguay', label: 'Paraguay'},
  {id: 'Peru', label: 'Peru'},
  {id: 'Philippines', label: 'Philippines'},
  {id: 'Poland', label: 'Poland'},
  {id: 'Portugal', label: 'Portugal'},
  {id: 'Qatar', label: 'Qatar'},
  {id: 'Romania', label: 'Romania'},
  {id: 'Russia', label: 'Russia'},
  {id: 'Saudi Arabia', label: 'Saudi Arabia'},
  {id: 'Serbia', label: 'Serbia'},
  {id: 'Singapore', label: 'Singapore'},
  {id: 'Slovakia', label: 'Slovakia'},
  {id: 'Slovenia', label: 'Slovenia'},
  {id: 'South Africa', label: 'South Africa'},
  {id: 'South Korea', label: 'South Korea'},
  {id: 'Spain', label: 'Spain'},
  {id: 'Sri Lanka', label: 'Sri Lanka'},
  {id: 'Sweden', label: 'Sweden'},
  {id: 'Switzerland', label: 'Switzerland'},
  {id: 'Syria', label: 'Syria'},
  {id: 'Taiwan', label: 'Taiwan'},
  {id: 'Tanzania', label: 'Tanzania'},
  {id: 'Thailand', label: 'Thailand'},
  {id: 'Tunisia', label: 'Tunisia'},
  {id: 'Turkey', label: 'Turkey'},
  {id: 'Ukraine', label: 'Ukraine'},
  {id: 'United Arab Emirates', label: 'United Arab Emirates'},
  {id: 'United Kingdom', label: 'United Kingdom'},
  {id: 'United States', label: 'United States'},
  {id: 'Uruguay', label: 'Uruguay'},
  {id: 'Uzbekistan', label: 'Uzbekistan'},
  {id: 'Venezuela', label: 'Venezuela'},
  {id: 'Vietnam', label: 'Vietnam'},
  {id: 'Yemen', label: 'Yemen'},
  {id: 'Zimbabwe', label: 'Zimbabwe'},
];
